import { withLoader } from 'util/routeHelper';
import { openMessageModal } from 'actions/modal';

export default store => ({
	path: 'forget',
	indexRoute: {
		getComponent: withLoader(
			(nextState, cb) =>
				require.ensure(
					[],
					require => {
						const component = require('./component').default;
						cb(null, component);
					},
					'Forget',
				),
			store,
			'FORGET',
		),
	},
	onEnter: () => {
		store.dispatch(openMessageModal('loginSignup', { type: 'newPassword' }));
	},
});



// WEBPACK FOOTER //
// ./src/routes/Forget/index.js